module.exports = __webpack_public_path__ + "img/china.6112349a.png";